import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_patient_summary = _resolveComponent("patient-summary")!
  const _component_patient_demographics = _resolveComponent("patient-demographics")!
  const _component_patient_search = _resolveComponent("patient-search")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "4" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, {
              class: "rounded-shaped",
              color: "blue-grey-lighten-1",
              variant: "tonal"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [
                        _createTextVNode("mdi-account")
                      ]),
                      _: 1
                    }),
                    _createTextVNode(" Patient Registration ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "8 text-right" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_tooltip, {
              text: "Search Patient",
              location: "top"
            }, {
              activator: _withCtx(({ props }) => [
                _createVNode(_component_v_btn, _mergeProps({ class: "mr-2" }, props, {
                  onClick: _ctx.onSearch,
                  "prepend-icon": "mdi-account-search"
                }), {
                  default: _withCtx(() => [
                    _createTextVNode(" Patient ")
                  ]),
                  _: 2
                }, 1040, ["onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_tooltip, {
              text: "Create New Registration",
              location: "top"
            }, {
              activator: _withCtx(({ props }) => [
                _createVNode(_component_v_btn, _mergeProps(props, {
                  class: "mr-2",
                  color: "blue",
                  onClick: _ctx.onNew
                }), {
                  default: _withCtx(() => [
                    _createTextVNode("New")
                  ]),
                  _: 2
                }, 1040, ["onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_btn, {
              class: "mr-2",
              color: "success"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Save")
              ]),
              _: 1
            }),
            _createVNode(_component_v_btn, { color: "error" }, {
              default: _withCtx(() => [
                _createTextVNode("Cancel")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_ctx.patient && !_ctx.newPatient)
      ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "12" }, {
              default: _withCtx(() => [
                _createVNode(_component_patient_summary, { patient: _ctx.patient }, null, 8, ["patient"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.newPatient)
      ? (_openBlock(), _createBlock(_component_patient_demographics, {
          key: 1,
          patient: _ctx.patient
        }, null, 8, ["patient"]))
      : _createCommentVNode("", true),
    (_ctx.patient && !_ctx.newPatient)
      ? (_openBlock(), _createBlock(_component_patient_demographics, {
          key: 2,
          patient: _ctx.patient
        }, null, 8, ["patient"]))
      : _createCommentVNode("", true),
    (_ctx.searchPatient)
      ? (_openBlock(), _createBlock(_component_v_row, { key: 3 }, {
          default: _withCtx(() => [
            _createVNode(_component_patient_search, { onSelectedPatient: _ctx.selectedPatient }, null, 8, ["onSelectedPatient"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}